const e = /* @__PURE__ */ new Set();
function n(t) {
  return e.has(t) ? !1 : (e.add(t), !0);
}
export {
  n as claimAnalyticsEvent
};
//# sourceMappingURL=eventGuard.js.map
